<app-service-detail>
    <app-apfiletabs class="container-fluid mb-3 px-5"></app-apfiletabs>
    <div class="col-md-12"
         *ngIf="serviceId">
        <form class="form-validation">
            <div class="form-group">
                <div class="row">
                    <div class="col-md-12">
                        <agm-map [latitude]="lat"
                                 [longitude]="lng"
                                 [zoom]="zoom"
                                 (mapClick)="mapClicked($event)">
                            <agm-marker-cluster imagePath="https://raw.githubusercontent.com/googlemaps/v3-utility-library/master/markerclustererplus/images/m">
                                <agm-marker *ngFor="let location of serviceLocations; let i = index"
                                            (markerClick)="clickedMarker(location.name, i)"
                                            (dragEnd)="dragEnd($event, i)"
                                            [latitude]="location.lat"
                                            [longitude]="location.lng"
                                            [label]="{color: '#421E17', fontSize: '20', fontWeight: 'bold', text: location.name}"
                                            [markerDraggable]="true">
                                </agm-marker>
                            </agm-marker-cluster>
                        </agm-map>
                    </div>
                </div>
            </div>
            <marker-modal [show]="showMarkerModal"
                          *ngIf="serviceLocations"
                          [location]="serviceLocations[modalIndex]"
                          (doAction)=doAction($event)></marker-modal>
        </form>
    </div>
</app-service-detail>

<confirmation-modal [show]="showAddWarningModal"
                    (onYes)="submitAddEvent()"
                    (onNo)="showAddWarningModal = false"
                    question="Do you want to add a marker?">